import axios from "axios";
import { urlAPI } from "../../config/config";
import { showSnackbar } from "../../redux/actions";
import { IRegieSimulationInputs, IRegieSimulation } from "../../interface/regie";

export const saveRegieSimulation = async (
  salaryId: string,
  inputs: IRegieSimulationInputs,
  token: string,
  onSaved: (simulation: IRegieSimulation) => void,
  dispatch: Function,
  setError: Function
) => {
  try {
    const response = await axios.post(
      `${urlAPI}/regie/simulations`,
      { salaryId, inputs },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    onSaved(response.data.message);
    dispatch(showSnackbar("Simulation enregistrée avec succès.", "success"));
  } catch (error: any) {
    console.error(error);
    setError(error?.response?.data?.error || "Impossible d'enregistrer la simulation.");
    dispatch(showSnackbar("Erreur lors de l'enregistrement de la simulation.", "error"));
  }
};
